import { render, staticRenderFns } from "./Storeslist.vue?vue&type=template&id=78d8013a&scoped=true&"
import script from "./Storeslist.vue?vue&type=script&lang=js&"
export * from "./Storeslist.vue?vue&type=script&lang=js&"
import style0 from "./Storeslist.vue?vue&type=style&index=0&id=78d8013a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d8013a",
  null
  
)

export default component.exports